import {useEffect} from 'react';
import {useNavigate} from 'react-router';

import ROUTE_PATHS from '@/consts/routePaths';
import routerService, {setNavigate} from '@/services/route/routerService';

const useNavigateInit = () => {
    const navigate = useNavigate();
    setNavigate(navigate);

    useEffect(() => {
        routerService.replace(ROUTE_PATHS.BADGES);
    }, []);
};

export default useNavigateInit;
